module.exports = __webpack_public_path__ + "static/media/traycorp-manual-import2.eb914903.png";